import * as React from "react";

import "./optout-edition-modal.scss";

import {bindInput}     from "@Common/react/bind-input";
import {cs}            from "@Common/react/chain-services";
import {Trimmer}       from "@Common/react/trimmer";
import {UseState}      from "@Common/react/use-state";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const OptoutEditionModal = ({next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3<any>({
        // xToClose: false,
        xdQaName: "Opt-Out of the Edition",
        // title: `Unenroll from ${program?.programPreferences?.linkName} Program`,
        width: 500,
        contentService: ({params: {pe}, close, next: next1}) => next1({
            title: `Opt-Out of the ${pe.name} Edition?`,
            getContent: () => next({
                pe, close,
            }),
        }),
        rootNext,
    })],
    ({modal: {pe, close}}) => (
        <div className="optout-edition-modal-51l">

            <div className="content">
                <div className="message">
                    Are you sure you want to opt-out of the <b>{pe.name}</b> Edition?{" "}
                    By removing this edition, you will be opting out of this particular mailing.{" "}
                    Please note, you may opt back in at any time before the Enrollment Deadline.{" "}
                    Are you sure you want to opt-out?
                </div>
            </div>
            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: () => close(false),
                    "xd-qa-type": "button",
                    "xd-qa-name": "Cancel",
                }}>
                    Cancel
                </button>

                <button {...{
                    className: "next",
                    onClick: () => close(true),
                    "xd-qa-type": "button",
                    "xd-qa-name": "Opt-Out",
                }}>
                    Opt-Out
                </button>
            </div>
        </div>
    )
);
